import React, { type FC } from 'react';

import { type TestOutcomesTestOutcomeSummaryFragment } from './__generated-gql-types__/TestOutcome.generated';

interface TestOutcomesProps {
  outcome: TestOutcomesTestOutcomeSummaryFragment;
  coachName: Possible<string>;
  className?: string;
}

export const TestOutcomes: FC<TestOutcomesProps> = ({
  outcome,
  coachName,
  className = '',
}) => {
  return (
    <div className={className}>
      <p className="text-leland-gray-light">
        {coachName
          ? `${coachName} has helped clients achieve `
          : 'Customers who purchased packages have achieved '}
        these scores on the {outcome.category.name}
      </p>
      <h1 className="mt-1 text-xl font-medium text-leland-gray-dark">
        {outcome.scoreRange}
      </h1>
    </div>
  );
};
